var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-title"},[_c('span',{staticClass:"hero-badge"},[_vm._v("Clínica veterinaria")]),_c('h1',[_vm._v(" Cuida la salud"),_c('br'),_vm._v(" de tu mascota ")]),_c('p',{staticClass:"hero-text"},[_vm._v(" Atención veterinaria cercana, profesional y de confianza ")])])
}]

export { render, staticRenderFns }